/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import { useBooking } from "../hooks/useBooking";
import FooterStepButton from "../components/FooterStepButton";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import BookingStepList from "../components/booking/steps/BookingStepList";
import ServiceProductsCard from "../components/booking/product/ServiceProductsCard";
import { useStepManager } from "../hooks/useStepManager";

const Products = () => {
  const { selectedServices, handleProductSelect, updateProduct, addDefaultProducts } = useBooking();
  const { navigateToNextStep } = useStepManager();

  const hasAvailableProducts = selectedServices.some((service) => service.has_available_products);

  useEffect(() => {
    if (!hasAvailableProducts) {
      navigateToNextStep({ replace: true });
    }
  }, [hasAvailableProducts]);

  if (!hasAvailableProducts) return null;

  return (
    <Container>
      <NavigationHeader location back="step" />
      <BookingStepList title="Products you may like">
        {selectedServices.map((service) => (
          <ServiceProductsCard
            key={service.id}
            service={service}
            handleProductSelect={handleProductSelect}
            updateProduct={updateProduct}
            addDefaultProducts={addDefaultProducts}
          />
        ))}
      </BookingStepList>
      <FooterStepButton services={selectedServices} />
    </Container>
  );
};

export default Products;